import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController, ToastController } from '@ionic/angular';
import { AppSettings } from '../enums/app-settings.enum';
import { uaePassDocStatus } from '../enums/uae-pass-doc.enum';
import { AlertService } from '../services/alert.service';
import { LanguageSwitchService } from '../services/language-switch.service';
import { SessionTimeoutComponent } from '../shared/session-timeout/session-timeout.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { ApplicationErrorCodesInitializationService } from '../services/application-error-codes-initialization.service';
@Injectable({
  providedIn: 'root',
})
export class UtilitiesService {

  ANURL: string;
  constructor(
    private route: ActivatedRoute,
    private LSS: LanguageSwitchService,
    private ALS: AlertService,
    private toastController: ToastController,
    private modalController: ModalController,
    private http: HttpClient,
    private applicationErrorCodesInitializationService:ApplicationErrorCodesInitializationService,
  ) { }

  private AHURL: string = `en${AppSettings.APPLICATION_HEADER_URL}`;
  private AFURL: string = `en${AppSettings.APPLICATION_FOOTER_URL}`;
  private planData: string = 'planData';

  setAHURL(U: string): void {
    this.AHURL = U;
  }

  getAHURL() {
    return this.AHURL;
  }
  getUserId(){
    let userInfo;
    if (
      localStorage.getItem('USER_ID') != 'undefined' &&
      localStorage.getItem('USER_ID') != null
    )
    {
       userInfo = JSON.parse(localStorage.getItem('USER_ID'));
    }

    if(userInfo){
      return userInfo ;
    }
    return null;
  }

  setAFURL(U: string): void {
    this.AFURL = U;
  }
  setANURL(U: string): void {
    this.ANURL = U;
  }

  getAFURL() {
    return this.AFURL;
  }

  getANURL() {
    return this.ANURL;
  }
  public getSelectedLanguage() {
    return new Promise((resolve, reject) => {
      this.route.queryParamMap.subscribe((params) => {
        const token: any = { ...params };
        const lang = token.params.locale
          ? token.params.locale.toLowerCase()
          : undefined;
        if (lang === 'ar') {
          this.LSS.setLanguage('ar');
          this.setAHURL(`ar${AppSettings.APPLICATION_HEADER_URL}`);
          this.setAFURL(`ar${AppSettings.APPLICATION_FOOTER_URL}`);
          this.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
          const urls = {
            APPLICATION_HEADER_URL: 'ar' + AppSettings.APPLICATION_HEADER_URL,
            APPLICATION_FOOTER_URL: 'ar' + AppSettings.APPLICATION_FOOTER_URL,
            APPLICATION_NAVIATION_URL:
              'ar' + AppSettings.APPLICATION_NAVIATION_URL,
          };
          resolve(urls);
        } else {
          this.LSS.setLanguage('en');
          this.setAHURL(`en${AppSettings.APPLICATION_HEADER_URL}`);
          this.setAFURL(`en${AppSettings.APPLICATION_FOOTER_URL}`);
          this.setANURL(`ar${AppSettings.APPLICATION_NAVIATION_URL}`);
          const urls = {
            APPLICATION_HEADER_URL: 'en' + AppSettings.APPLICATION_HEADER_URL,
            APPLICATION_FOOTER_URL: 'en' + AppSettings.APPLICATION_FOOTER_URL,
            APPLICATION_NAVIATION_URL:
              'en' + AppSettings.APPLICATION_NAVIATION_URL,
          };
          resolve(urls);
        }
      });
    });
  }
  getLocaleLanguage(): string {
    const language = this.LSS.getLanguage();
    if (language) return language;
    else {
      if (localStorage.getItem('language')) {
        return localStorage.getItem('language');
      }
    }
    return 'en';
  }
  setLocaleLanguage(L) {
    if (L) {
      localStorage.setItem('language', L.toLocaleLowerCase());
    }
  }

  log(D: any) {
    console.log(D);
  }
  error(E: any) {
    this.clearError();
    this.ALS.error(E);
    // this.toast(E);
    setTimeout(() => {
      this.clearError();
    }, 8000);
  }
  clearError() {
    this.ALS.clearAll();
  }

  getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
  createCookie(name, value, days) {
    var expires = '';

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = ';expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + value + expires;
    return '';
  }

  createCookieWithinDay(name, value, minutes): any {
    var expires = '';

    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      expires = ';expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + value + expires;
    return "";
  }
  async toast(M: string) {
    const toast = await this.toastController.create({
      message: `${M}`,
      duration: 2000,
    });
    toast.present();
  }

  getHeaders() {
    const req = new XMLHttpRequest();
    req.open('GET', window.location.href, false);
    req.send(null);
    const headers = req.getAllResponseHeaders().toLowerCase();
  }

  uniqByKeepLast(a, key) {
    return [...new Map(a.map((x) => [key(x), x])).values()];
  }
  uniqByKeepFirst(a, key) {
    let seen = new Set();
    return a.filter((item) => {
      let k = key(item);
      return seen.has(k) ? false : seen.add(k);
    });
  }
  getBrowserInfo() {
    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf('Opera')) != -1) {
      browserName = 'Opera';
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
      browserName = 'Microsoft Internet Explorer';
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
      browserName = 'Chrome';
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
      browserName = 'Safari';
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
      browserName = 'Firefox';
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if (
      (nameOffset = nAgt.lastIndexOf(' ') + 1) <
      (verOffset = nAgt.lastIndexOf('/'))
    ) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }

    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) != -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(' ')) != -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = '' + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }
    return browserName;
  };


  async openSessionTimeout() {
    const modal = await this.modalController.create({
      component: SessionTimeoutComponent,
      cssClass: 'verification-modal modal-fullscreen',
      componentProps: { countDownTime: 15 },
    });
    return await modal.present();
  }

  removeDuplicatefromItems(arr) {
    const res = {};
    arr.forEach((obj) => {
      const key = `${obj.skuId}`;
      if (!res[key]) {
        res[key] = { ...obj, quantity: 0 }
      };
      res[key].quantity += 1;
    });
    return Object.values(res);
  }

  format(phoneNumber) {
    return phoneNumber.replace(/\s+/g, '').replace(/^(.{3})(.{3})(.*)$/, "$1 $2 $3");
  }


  setENV(e) {
    localStorage.setItem('ENV', e);
  }

  getENV() {
    const e = localStorage.getItem('ENV');
    if (e) {
      if (e == 'mobile') {
        return e;
      } else {
        return 'web';
      }
    } else {
      return 'web';
    }
  }

  setAccessToken(e) {
    localStorage.setItem('AccessToken', e);
  }

  getAccessToken() {
    const e = localStorage.getItem('AccessToken');
    if (e) {
      return e;
    }
    return null;
  }


  setMagentoCartId(e) {
    localStorage.setItem('magentoCartId', e);
  }

  getMagentoCartId() {
    const e = localStorage.getItem('magentoCartId');
    if (e) {
      return e;
    }
    return null;
  }

  setWSO2AccessToken(e) {
    localStorage.setItem('wso2AccessToken', e);
  }

  getWSO2AccessToken() {
      const e = localStorage.getItem('wso2AccessToken');
      if (e) {
        return e;
      }
      return null;
    }
    setIndividualLoginAccountNo(e) {
      localStorage.setItem('individualLoginAccountNo', e);
    }
  
    getIndividualLoginAccountNo() {
        const e = localStorage.getItem('individualLoginAccountNo');
        if (e) {
          return e;
        }
        return null;
      }
  setJSessionID(e) {
    localStorage.setItem('JSESSIONID', e);
  }

  getJSessionID() {
    const e = localStorage.getItem('JSESSIONID');
    if (e) {
      return e;
    }
    return null;
  }

  isMobileDevice() {
    return /Mobi/i.test(window.navigator.userAgent);
  }

  getMobileOperatingSystem() {
    const userAgent = navigator.userAgent || navigator.vendor;
    const isAndroid = (/android/i.test(userAgent)) ? true : false;
    if (isAndroid) {
      return 'Android';
    }
    return 'iOS';

  }


  setBigIpServer(e) {
    sessionStorage.setItem('BIGipServerb2cprod_443_pool', e);
    document.cookie = 'BIGipServerb2cprod_443_pool=' + e;
  }

  getBigIpServer() {
    const e = sessionStorage.getItem('BIGipServerb2cprod_443_pool');
    if (e) {
      return e;
    }
    return null;
  }
  isHighValue(commerceItem) {

    let isHighValue = false;
    if (commerceItem.highValueConfig && commerceItem.highValueConfig != null
      && commerceItem.highValueConfig.isHighValue == true && commerceItem.highValueConfig.restrictionEndDate) {
      var currentDate = new Date();
      var restrictionEndDate = new Date(commerceItem.highValueConfig.restrictionEndDate.split(' ')[0]);
      if (currentDate <= restrictionEndDate) {
        isHighValue = true;
      }
    } else {
      isHighValue = false;
    }
    return isHighValue;
  }


  setDeviceType(e) {
    localStorage.setItem('DeviceType', e);
  }

  getDeviceType() {
    const e = localStorage.getItem('DeviceType');
    if (e) {
      return e;
    }
    return '';
  }

  deleteAllCookies() {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }
  setUaePassProperties(resp: any) {
    if (sessionStorage.getItem('uaePassFlow')) {
      var documentSubmissionStatus = resp?.data?.documentSubmissionStatus;
      let docSubStatus = "";
      if (documentSubmissionStatus != null) {
        if (documentSubmissionStatus == 0 || documentSubmissionStatus == '0') {
          docSubStatus = uaePassDocStatus.NOT_REQUIRED;
        }
        else if (documentSubmissionStatus == 1 || documentSubmissionStatus == '1') {
          docSubStatus = uaePassDocStatus.PENDING;
        }
        else if (documentSubmissionStatus == 2 || documentSubmissionStatus == '2') {
          docSubStatus = uaePassDocStatus.SUBMITTED_UAEPASS;
        }
        else if (documentSubmissionStatus == 3 || documentSubmissionStatus == '3') {
          docSubStatus = uaePassDocStatus.SUBMITTED_NORMAL;
        }
      }
      let uaePassProperties = {
        uaePassFlow: true,
        documentSubmissionStatus: docSubStatus
      }
      sessionStorage.setItem('uaePassProperties', JSON.stringify(uaePassProperties));

    }
  }
  // goToCart() {
  //   let ENV = this.getENV();
  //   let OS =this.getMobileOperatingSystem();

  //   let currentLanguage = this.getLocaleLanguage();
  //   if(ENV == 'mobile' && this.appInitService?.environmentConfig.ENABLE_CART_MOBILE_FLOW == 'TRUE'){
  //     if (OS == 'Android') {
  //       (window as any).deals.goToCartScreen();
  //     } else if (OS == 'iOS') {
  //       (window as any).webkit.messageHandlers.hybridInterface.postMessage(
  //         'cart'
  //       );
  //     }
  //     return;
  //   } else {
  //     window.location.href = `${window.location.origin}/b2c/heshop/checkoutApp/cart?lang=${currentLanguage}`;
  //     return;
  //   }
  // }
  getJSID() {
    const JSID = sessionStorage.getItem('JSID');
    const JSID_SET_TIME = sessionStorage.getItem('JSID_SET_TIME');
    if (
      JSID &&
      JSID_SET_TIME &&
      this.isTimeDifferenceLessThan15Minutes(JSID_SET_TIME)
    ) {
      return JSID;
    } else {
      this.http
        .post(environment?.B2C_URL + '/getCustomerJsession.service', {})
        .subscribe(async (r: any) => {
          if (r && r.JSESSIONID) {
            sessionStorage.setItem('JSID', r.JSESSIONID);
            sessionStorage.setItem(
              'JSID_SET_TIME',
              Number(Date.now()).toString()
            );
            return r.JSESSIONID;
          } else {
            return '';
          }
        });
    }
  }
  isTimeDifferenceLessThan15Minutes(T) {
    const now = moment();
    const targetTime = new Date(Number(T));
    const timeDifference = now.diff(targetTime, 'minutes');
    return timeDifference < 15;
  }

  logActivity(payload: any) {
    const specifiedDevice =
    this.getENV() == 'mobile'
      ? this.getMobileOperatingSystem()
      : '';
    const userInfo = this.getUserInfo();
    const journeyType = (userInfo && userInfo?.loginMethod && userInfo?.loginMethod == '2') ? 'UAE PASS' : 'NORMAL';
    let activityLog = {
      channel: '',
      transactionId: '',
      subChannel: '',
      jsession: payload?.information,
      event: payload?.event,
      eventAction: payload?.eventAction,
      eventCategory: payload?.eventCategory,
      eventLabel: payload?.eventLabel,
      clickedUrl: payload?.clicked_url,
      userEnv: payload?.user_env,
      platform: specifiedDevice,
      journeyType: journeyType
    };

    this.http
      .post(environment?.B2C_URL + '/logActivity.service', activityLog)
      .subscribe(
        (res) => {
      //    this.log(res)
        },
        (e) => {
      //    this.log(e);
        }
      );
  }
   getUserInfo(){
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if(localStorage.getItem('userInfo')){
      return userInfo
    }
    return null;
  }
  clearTravelInsuranceData(){
    localStorage.getItem('isTravelInsuranceAddon') ? localStorage.removeItem('isTravelInsuranceAddon') : null;
    sessionStorage.getItem('visitorLineTravelAddon') ? localStorage.removeItem('visitorLineTravelAddon'): null;
  }
  //EC isfor errorCode
  searchErrorCode(EC) {
    const jsonData: any = this.applicationErrorCodesInitializationService?.errorCodesConfig;
    if (EC) {
      if (jsonData.hasOwnProperty(EC)) {
        // Key "error-code-001" found, do something with it
        const error001 = jsonData[EC];

        // Convert the "ar" key from Unicode to simple text
        error001["errorCode"] = EC;
        error001["found"] = true;
        error001.ar = this.fromUnicode(error001.ar);
                return error001;
      } else {
        // Key not found, return "0"
        const error0 = jsonData["0"] || {};
        error0["errorCode"] = EC;
        error0["found"] = false;
        error0.ar = this.fromUnicode(error0.ar);
        return error0;
      }
    }
    else {
      // Key not found, return "0"
      const error0 = jsonData["0"];
      error0["errorCode"] = EC;
      error0["found"] = false;
      error0.ar = this.fromUnicode(error0.ar);
      return error0;
    }
  }
   // Function to convert Unicode representation back to simple text
   fromUnicode(input) {
    return input?.split('\\u')?.filter(Boolean)?.map(function (hexCode) {
      return String.fromCharCode(parseInt(hexCode, 16));
    }).join('');
  }
  setUserInfo(userinfo:any){
    if(userinfo){
      if(userinfo?.imageBase64String || userinfo?.wso2AccessToken){
        userinfo['imageBase64String'] = "";
        userinfo['wso2AccessToken'] = "";
      }
      localStorage.setItem('userInfo', JSON.stringify(userinfo));
    }
  }

  toUnicode(theString) {
    var unicodeString = '';
    for (var i = 0; i < theString.length; i++) {
      var theUnicode = theString.charCodeAt(i).toString(16).toUpperCase();
      while (theUnicode.length < 4) {
        theUnicode = '0' + theUnicode;
      }
      theUnicode = '\\u' + theUnicode;
      unicodeString += theUnicode;
    }
    return unicodeString;
  }
  
  getEmirate(emirate) {
    
    var emirateUnicode = this.toUnicode(emirate);
    if (
      (
        emirateUnicode.indexOf("\\u0044\\u0075\\u0062\\u0061\\u0069") != -1 ||
        emirateUnicode.indexOf("\\u062F\\u0628\\u064A") != -1)
      || (
        emirateUnicode.indexOf('\u0044\u0075\u0062\u0061\u0069') != -1 ||
        emirateUnicode.indexOf('\u062F\u0628\u064A') != -1)) {
      emirate = "DXB";
    } else if (
      (
        emirateUnicode.indexOf("\\u0044\\u0068\\u0061\\u0062\\u0069") != -1 ||
        emirateUnicode.indexOf("\\u0638\\u0628\\u064A") != -1) ||
      (
        emirateUnicode.indexOf("\u0044\u0068\u0061\u0062\u0069") != -1 ||
        emirateUnicode.indexOf("\u0638\u0628\u064A") != -1)) {
      emirate = "AUH";
    } else if (
      (
        emirateUnicode.indexOf("\\u0053\\u0068\\u0061\\u0072\\u006A\\u0061\\u0068") != -1 ||
        emirateUnicode.indexOf("\\u0634\\u0627\\u0631\\u0642\\u0629") != -1) ||
      (
        emirateUnicode.indexOf("\u0053\u0068\u0061\u0072\u006A\u0061\u0068") != -1 ||
        emirateUnicode.indexOf("\u0634\u0627\u0631\u0642\u0629") != -1)) {
      emirate = "SHJ";
    } else if (
      (
        emirateUnicode.indexOf("\\u0041\\u006A\\u006D\\u0061\\u006E") != -1 ||
        emirateUnicode.indexOf("\\u0639\\u062C\\u0645\\u0627\\u0646") != -1) ||
      (
        emirateUnicode.indexOf("\u0041\u006A\u006D\u0061\u006E") != -1 ||
        emirateUnicode.indexOf("\u0639\u062C\u0645\u0627\u0646") != -1
      )
    ) {
      emirate = "AJM";
    } else if (
      (
        emirateUnicode.indexOf("\\u004B\\u0068\\u0061\\u0069\\u006D\\u0061\\u0068") != -1 ||
        emirateUnicode.indexOf("\\u0627\\u0644\\u062E\\u064A\\u0645\\u0629") != -1) ||
      (
        emirateUnicode.indexOf("\u004B\u0068\u0061\u0069\u006D\u0061\u0068") != -1 ||
        emirateUnicode.indexOf("\u0627\u0644\u062E\u064A\u0645\u0629") != -1
      )
    ) {
      emirate = "RAK";
    } else if (
      (
        emirateUnicode.indexOf("\\u0051\\u0075\\u0077\\u0061\\u0069\\u006E") != -1 ||
        emirateUnicode.indexOf("\\u0642\\u064A\\u0648\\u064A\\u0646") != -1) ||
      (
        emirateUnicode.indexOf("\u0051\u0075\u0077\u0061\u0069\u006E") != -1 ||
        emirateUnicode.indexOf("\u0642\u064A\u0648\u064A\u0646") != -1
      )
    ) {
      emirate = "UAQ";
    } else if (
      (
        emirateUnicode.indexOf("\\u0046\\u0075\\u006A\\u0061\\u0069\\u0072\\u0061\\u0068") != -1 ||
        emirateUnicode.indexOf("\\u0641\\u062C\\u064A\\u0631\\u0629") != -1) ||
      (
        emirateUnicode.indexOf("\u0046\u0075\u006A\u0061\u0069\u0072\u0061\u0068") != -1 ||
        emirateUnicode.indexOf("\u0641\u062C\u064A\u0631\u0629") != -1
      )
    ) {
      emirate = "FUJ";
    }
    return emirate;

  }
  
  private isValid(value: any): boolean {
    return value !== undefined && value !== null && value !== 'null';
  }

  initializeFromQueryParams(q: any): void {
    if (!q) return;
 
    if (q.env) this.setENV(q.env);
    if (this.isValid(q.deviceType)) this.setDeviceType(q.deviceType);
    if (this.isValid(q['access-token'])) this.setAccessToken(q['access-token']);
    if (this.isValid(q.JSESSIONID)) this.setJSessionID(q.JSESSIONID);
    if (this.isValid(q.bigIpServer)) this.setBigIpServer(q.bigIpServer);
    if (this.isValid(q.magentoCartId)) this.setMagentoCartId(q.magentoCartId);
    if (this.isValid(q.access_token)) this.setWSO2AccessToken(q.access_token);
    if (this.isValid(q.individualLoginAccountNo)) this.setIndividualLoginAccountNo(q.individualLoginAccountNo);
  }

  setPlanData(plan: any) {
    const data = JSON.stringify(plan);
    sessionStorage.setItem(this.planData, data);
    localStorage.setItem(this.planData, data);
  }
 
  getPlanData(): any {
    try {
      const data = sessionStorage.getItem(this.planData) || localStorage.getItem(this.planData);
      return data ? JSON.parse(data) : {};
    } catch (err) {
      console.error('Error parsing planData:', err);
      return {};
    }
  }

  clearPlanData() {
    sessionStorage.removeItem(this.planData);
    localStorage.removeItem(this.planData);
  }
}